import { render, staticRenderFns } from "./imgPurchase.vue?vue&type=template&id=564ea15b&scoped=true"
import script from "./imgPurchase.vue?vue&type=script&lang=js"
export * from "./imgPurchase.vue?vue&type=script&lang=js"
import style0 from "./imgPurchase.vue?vue&type=style&index=0&id=564ea15b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564ea15b",
  null
  
)

export default component.exports